import React, { FunctionComponent, memo } from 'react'

import { ZustavateTableItem } from '../../utils/useZustavateData'
import { ZustavateNoteEdit } from '../ZustavateNoteEdit/ZustavateNoteEdit'
import { ZustavateRecordDelete } from '../ZustavateRecordDelete/ZustavateRecordDelete'

export interface ZustavateDataTableActionProps {
  record: ZustavateTableItem
  onUpdate?: () => void
}

export const ZustavateDataTableAction: FunctionComponent<ZustavateDataTableActionProps> =
  memo(({ record, onUpdate }) => {
    return (
      <div className="space-y-1">
        {(record.message || record.lastMessage) && (
          <div className="text-gray-400">
            <span className="font-semibold">Od zákazníka: </span>
            <span>
              {record.message} {record.lastMessage}
            </span>
          </div>
        )}
        <div className="flex items-start justify-between gap-2">
          <div className="flex-1">
            {record.note ? (
              <div>{record.note}</div>
            ) : (
              <div className="text-gray-400">---</div>
            )}
          </div>
          <div className="flex space-x-2">
            <ZustavateNoteEdit record={record} onUpdate={onUpdate} />
            <ZustavateRecordDelete record={record} onDelete={onUpdate} />
          </div>
        </div>
      </div>
    )
  })
